import { FirstName } from '@dreryk/person-name-common-api';

import { commonTranslationKeys, FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

export type FirstNameValue = { firstName: string | null };
type FirstNameInputProps = Pick<FormContextValues<FirstNameValue>, 'register'>;

export const FirstNameInput = (props: FirstNameInputProps): JSX.Element => {
   const controller = props.register('firstName', {
      required: true,
      maxLength: FirstName.MAX_LENGTH,
   });

   return <TextInput testId={'firstName'} label={commonTranslationKeys.firstName} controller={controller} />;
};
